import { RefundRequestStatus } from '@ivy-monorepo/shared'

export const REFUND_STATUS_LABELS: Record<RefundRequestStatus, string> = {
  [RefundRequestStatus.Pending]: 'In review',
  [RefundRequestStatus.Processing]: 'Refunding',
  [RefundRequestStatus.Refunded]: 'Refunded',
  [RefundRequestStatus.Rejected]: 'Declined',
  [RefundRequestStatus.Failed]: 'Refund failed',
}

/** Statuses that still need an admin or Square to act. */
export const NEEDS_ATTENTION_REFUND_STATUSES: RefundRequestStatus[] = [
  RefundRequestStatus.Pending,
  RefundRequestStatus.Processing,
  RefundRequestStatus.Failed,
]

/**
 * The Refunds tab's default filter: every status, so finished refunds (and declines) stay visible
 * and can be opened read-only. The backend still lists ones that need action first.
 */
export const ALL_REFUND_STATUSES: RefundRequestStatus[] = Object.values(RefundRequestStatus)
